// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * SMS
 * ---------------------------------------------------------------------------------
 */
export const SMSService = {
    /**
     * GetSMS returns at most a single SMS.
     */
    GetSMS(fn, req) {
        return fn(`/sms/data/v3/sms?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListSMS returns a simple list of sms messages.
     */
    ListSMS(fn, req) {
        return fn(`/sms/data/v3/sms/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * SearchSMS returns a simple list of sms messages with a person.
     * DEPRECATED; use sms-search service instead.
     */
    SearchSMS(fn, req) {
        return fn(`/sms/data/v3/sms/search?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * DeleteSMS will mark the message as deleted by setting a date in the
     * database.
     */
    DeleteSMS(fn, req) {
        return fn(`/sms/data/v3/sms?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * ProcessSMSAutoResponse will update the read and actionable status of the
     * sms message and the containing thread.
     */
    ProcessSMSAutoResponse(fn, req) {
        return fn(`/sms/data/v3/sms/auto-response`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * THREAD
     * ---------------------------------------------------------------------------------
     *
     * GetThread returns a single thread matching the request criteria.
     */
    GetThread(fn, req) {
        return fn(`/sms/data/v3/thread?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * LookupThreadId is a fast way to look up a thread_id.
     */
    LookupThreadId(fn, req) {
        return fn(`/sms/data/v3/thread/id?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListThreads returns a list of threads matching the search criteria.
     */
    ListThreads(fn, req) {
        return fn(`/sms/data/v3/threads/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListThreadsCount returns the count of threads matching filter criteria.
     */
    ListThreadsCount(fn, req) {
        return fn(`/sms/data/v3/threads/list:count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * SetThreadsTag associates/removes a tag to a list threads.
     */
    SetThreadsTag(fn, req) {
        return fn(`/sms/data/v3/threads/tag`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SetThreadsActionable associates/removes a actionable to a list threads.
     */
    SetThreadsActionable(fn, req) {
        return fn(`/sms/data/v3/threads/actionable`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SetThreadsStatusRead will mark threads as "read".
     */
    SetThreadsStatusRead(fn, req) {
        return fn(`/sms/data/v3/threads/status/read`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SetThreadsStatusNew will mark the thread as "new".
     * A thread status of "new" indicates the thread is unread.
     */
    SetThreadsStatusNew(fn, req) {
        return fn(`/sms/data/v3/threads/status/new`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetThreadStatus returns the status of a thread.
     */
    GetThreadStatus(fn, req) {
        return fn(`/sms/data/v3/threads/status?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    BatchGetThreadStatus(fn, req) {
        return fn(`/sms/data/v3/threads/status:batchGet?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * SetThreadsArchived sets the requested threads as archived.
     */
    SetThreadsArchived(fn, req) {
        return fn(`/sms/data/v3/threads/archived`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * SetThreadsUnarchived sets the requested threads as unarchived.
     */
    SetThreadsUnarchived(fn, req) {
        return fn(`/sms/data/v3/threads/unarchived`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DismissTagInThread removes a tag from a thread.
     */
    DismissTagInThread(fn, req) {
        return fn(`/sms/data/v3/threads:dismissTag`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * TAG
     * ---------------------------------------------------------------------------------
     *
     * CreateTag creates a new tag. Can optionally have a user assigned to the
     * tag.
     */
    CreateTag(fn, req) {
        return fn(`/sms/data/v3/tag`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * GetTag returns a single tag and tag info.
     */
    GetTag(fn, req) {
        return fn(`/sms/data/v3/tag?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListTags returns a list of all the tags that a location has.
     */
    ListTags(fn, req) {
        return fn(`/sms/data/v3/tag/list?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * UpdateTag takes a tag and updates the tag name or the user assigned to the
     * tag.
     */
    UpdateTag(fn, req) {
        return fn(`/sms/data/v3/tag`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DeleteTag removes the tag from the location's list of tags.
     */
    DeleteTag(fn, req) {
        return fn(`/sms/data/v3/tag?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    /**
     * DismissTag removes a v2 message-level tag from an sms.
     */
    DismissTag(fn, req) {
        return fn(`/sms/data/v3/sms:dismissTag`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ApplyTag applies a v2 message-level tag to an sms.
     */
    ApplyTag(fn, req) {
        return fn(`/sms/data/v3/sms:applyTag`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
